import Vue from 'vue'

import '@/scss/element.scss';
import ElementUI from 'element-ui';
Vue.use(ElementUI, {size: 'small'});
